<template>
	<div class="flex items-center justify-between border-b border-[#E9EEF2] px-[18px] py-[9px]">
		<div class="flex items-center gap-4">
			<ResumeIconBig />
			<DocumentName
				:resume-title="resumeTitle"
			/>
			<DocumentAccessRights />
		</div>
    
		<div class="flex items-center gap-2">
			<button
				class="
                    relative flex items-center justify-center rounded border
                    border-won-green px-3 py-1.5 font-[Roboto] text-base text-won-green
                    disabled:border-won-gray disabled:opacity-40
                "
				:disabled="duplicateLoading"
				@click="duplicateResumeHandler"
			>
				<span
					class="flex items-center gap-2"
				>
					<span v-if="duplicateLoading">
						<LoadingIcon
							size="size-[18px]"
						/>
					</span>

					<DocumentDuplicateIcon
						v-else
						class="size-[18px]"
					/>

					<span>Duplicate</span>
				</span>
			</button>

			<CopyShareLinkBtn
				v-if="isAuthenticated()"
				:disabled="false"
				button-size="size-[18px]"
			/>

			<ShareResumeBtn
				v-else
				:emit-click-event="true"
				@click-handler="authPopupStore.setShowAuthPopup"
			/>

			<button
				v-if="isAuthenticated()"
				:disabled="downloadLoading"
				class="
					flex h-8 w-[138px] cursor-pointer items-center justify-center rounded
					bg-[#b6dbc4] px-2 py-2.5 select-none
				"
				@click="downloadDocumentHandler"
			>
				<span class="won-blue text-sm font-medium">Download</span>
			</button>
		</div>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import { DocumentDuplicateIcon } from '@heroicons/vue/24/outline';
import { useBuilder } from '../../store/builder.store';
import { extractContent } from '../../utils/helpers';
import { setAuthState } from '../../composables/auth';
import { downloadPdf } from '../../api/download';

import { useAuthPopupStore } from '../../store/auth-popup.store';
import { useResumesStore } from '../../store/resumes.store';
import { useNotifications } from '../../store/notifications.store';

import ShareResumeBtn from '../resume-tool/share-resume-btn.vue';
import DocumentName from '../resume-tool/document-name.vue';
import DocumentAccessRights from '../resume-tool/document-access-rights.vue';
import ResumeIconBig from '../../icons/resume-icon-big.vue';
import CopyShareLinkBtn from '../resume-tool/copy-share-link-btn.vue';

import LoadingIcon from '../../icons/loading-icon.vue';

const { isAuthenticated } = setAuthState();

const route = useRoute();

const resumesStore = useResumesStore();
const builderStore = useBuilder();
const authPopupStore = useAuthPopupStore();
const notificationsStore = useNotifications();
const { data } = storeToRefs(builderStore);
const { duplicateLoading } = storeToRefs(resumesStore);

const downloadLoading = ref(false);

const resumeTitle = computed(() => {
	return extractContent(data.value.title);
});

const downloadDocumentHandler = async () => {
	downloadLoading.value = true;

	try {
		await downloadPdf({ shareToken: route.query.token }, extractContent(data.value.title));
	} catch {
		notificationsStore.notify('Failed to download the document!', 'error');
	} finally {
		downloadLoading.value = false;
	}
};

const duplicateResumeHandler = async () => {
	if (isAuthenticated()) {
		const resumeId = data.value.uuid;
		await resumesStore.duplicateResume(resumeId);
	} else {
		authPopupStore.setShowAuthPopup();
	}
};
</script>
